const passwordPattern = '^(?=.*).{8,}$';

export default passwordPattern;
